import invoice from '@/http/requests/invoice'
import cashRequest from '@/http/requests/cashRequest'

export default {
  fetchInvoiceList({ commit }, data) {
    return new Promise((resolve, reject) => {
      invoice
        .invoiceList(data)
        .then(response => {
          if (data.page > 1) {
            commit('UPDATE_INVOICE_LIST', response.data.data)
          } else {
            commit('SET_INVOICE_LIST', response.data.data)
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateQBInvoice({ commit }, data) {
    return new Promise((resolve, reject) => {
      invoice
        .updateQBInvoice(data.id, data.value)
        .then(response => {
          commit('UPDATE_INVOICE', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getCurrentPeriod({ commit }) {
    return new Promise((resolve, reject) => {
      invoice
        .getCurrentPeriod()
        .then(response => {
          commit('SET_PERIOD', response.data.period)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updatePeriodExchangeRate({ commit }, data) {
    return new Promise((resolve, reject) => {
      invoice
        .updatePeriodExchangeRate(data.period_id, data.newExchangeRate)
        .then(response => {
          commit('SET_PERIOD', response.data.period)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateHold({ commit }, data) {
    return new Promise((resolve, reject) => {
      cashRequest
        .changeInvoiceHold(data)
        .then(res => {
          commit('UPDATE_INVOICE', res.data.item)
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  linkPayrollsToInvoice({ commit }, data) {
    return new Promise((resolve, reject) => {
      cashRequest
        .linkPayrollsToInvoice(data)
        .then(res => {
          commit('UPDATE_INVOICE', res.data.item)
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getCountInvoiceReadyToSend(data) {
    return new Promise((resolve, reject) => {
      invoice
        .getCountInvoicesToSend(data)
        .then(res => {
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
